(function () {
  /*
    FundPop renders the pledge explanation ("Making a pledge means you pay X
    now...") inside a hidden modal behind a "What is a pledge?" link. We move
    that text into the pledge block so it reads inline, hide the link, and
    rewrite the wording to Randamu's own copy.

    The node is MOVED, not cloned: FundPop keeps updating the amounts and date
    by id (#fundpop-pledge-modal-amount and friends), and a clone would both
    duplicate those ids and go stale. For the same reason the rewrite REUSES
    those id-bearing spans instead of replacing them with static text — every
    element FundPop writes to survives, including the ones our copy no longer
    shows (they are kept hidden rather than removed).
  */

  var INLINED_ATTR = 'data-randamu-pledge-inline';
  var COPY_ATTR = 'data-randamu-pledge-copy';
  var CURRENCY_ATTR = 'data-randamu-currency';
  var MIRROR_ATTR = 'data-randamu-pledge-amount-mirror';

  var AMOUNT_ID = 'fundpop-pledge-modal-amount';
  var REMAIN_ID = 'fundpop-pledge-modal-remain-amount';
  var DATE_ID = 'fundpop-pledge-modal-date';
  var ALL_OR_NOTHING_ID = 'fundpop-pledge-modal-all-or-nothing';

  var TYPE_PILL_SELECTOR = '[data-product-type-pill]';
  var DEFAULT_TYPE_LABEL = 'Concept';

  var HEADING = 'What is a pledge?';
  var BODY_LEAD = 'A pledge means you pay ';
  var BODY_TAIL =
    ' + shipping and tax will be automatically charged. Your collectible will then be delivered within ' +
    'approximately 2 months from the charge date.';
  var REFUND_TAIL = ' pledge will be fully refunded.';

  function bodyMiddle(label) {
    return ' today to support this ' + label + '. Once the sample is ready, the remaining ';
  }

  function refundLead(label) {
    return 'If the ' + label + ' doesn’t reach its supporter goal, your ';
  }

  /*
    The copy names the product's own type. product-details renders the type pill
    above the title from the product's tags, so we read the label off that pill
    rather than re-deriving it here — this keeps the pledge text and the pill in
    agreement, including on custom concepts, which are fundpop campaigns the pill
    deliberately labels "Concept". Off a tagged product page the pill is absent,
    so fall back to "Concept".
  */
  function resolveTypeLabel(doc) {
    doc = doc || (typeof document !== 'undefined' ? document : null);
    if (!doc || typeof doc.querySelector !== 'function') return DEFAULT_TYPE_LABEL;

    var pill = doc.querySelector(TYPE_PILL_SELECTOR);
    if (!pill) return DEFAULT_TYPE_LABEL;

    var type = String(pill.getAttribute('data-product-type-pill') || '').trim().toLowerCase();
    return type === 'campaign' ? 'Campaign' : DEFAULT_TYPE_LABEL;
  }

  var CURRENCY_SYMBOLS = { USD: '$', CAD: '$', AUD: '$', NZD: '$', SGD: '$', EUR: '€', GBP: '£', JPY: '¥' };

  /*
    FundPop writes amounts as "2 USD" / "27.9 USD"; the copy asks for "$2.00".
    The currency code only appears in FundPop's own wording, so we remember it
    on the span — after the first rewrite the text no longer carries it.
  */
  function formatAmount(raw, node) {
    var text = String(raw == null ? '' : raw).trim();
    if (!text) return '';

    var codeMatch = text.match(/\b([A-Z]{3})\b/);
    var code = codeMatch ? codeMatch[1] : null;
    if (node) {
      if (code) node.setAttribute(CURRENCY_ATTR, code);
      else code = node.getAttribute(CURRENCY_ATTR);
    }

    var numberMatch = text.match(/-?[\d,]*\.?\d+/);
    if (!numberMatch) return text;
    var value = parseFloat(numberMatch[0].replace(/,/g, ''));
    if (isNaN(value)) return text;

    var symbol = code ? CURRENCY_SYMBOLS[code] : text.charAt(0) === '$' ? '$' : '';
    var fixed = value.toFixed(2);
    if (symbol) return symbol + fixed;
    return code ? fixed + ' ' + code : fixed;
  }

  function makeNode(doc, tag, text) {
    var node = doc.createElement(tag);
    if (text) node.textContent = text;
    return node;
  }

  function hide(node) {
    if (node && node.style) node.style.display = 'none';
  }

  /* Rebuilds the explanation in Randamu's wording around FundPop's own spans. */
  function renderCopy(doc, textModal) {
    if (textModal.getAttribute(COPY_ATTR) === 'true') return false;

    // Every span must be grabbed BEFORE the clear below: once detached they
    // are no longer reachable by id.
    var amount = doc.getElementById(AMOUNT_ID);
    var remain = doc.getElementById(REMAIN_ID);
    var carried = [doc.getElementById(DATE_ID), doc.getElementById(ALL_OR_NOTHING_ID)];
    if (!amount || !remain) return false;

    var typeLabel = resolveTypeLabel(doc);

    // Detaches FundPop's original sentence; the spans live on via our refs.
    textModal.textContent = '';

    var heading = makeNode(doc, 'div', HEADING);
    heading.className = 'randamu-pledge-heading';
    if (heading.style) {
      heading.style.fontWeight = '600';
      heading.style.marginBottom = '2px';
    }
    textModal.appendChild(heading);

    var body = makeNode(doc, 'div');
    body.className = 'randamu-pledge-body';
    body.appendChild(makeNode(doc, 'span', BODY_LEAD));
    body.appendChild(amount);
    body.appendChild(makeNode(doc, 'span', bodyMiddle(typeLabel)));
    body.appendChild(remain);
    body.appendChild(makeNode(doc, 'span', BODY_TAIL));
    textModal.appendChild(body);

    var refund = makeNode(doc, 'div');
    refund.className = 'randamu-pledge-refund';
    if (refund.style) refund.style.marginTop = '8px';
    refund.appendChild(makeNode(doc, 'span', refundLead(typeLabel)));
    var mirror = makeNode(doc, 'span');
    mirror.setAttribute(MIRROR_ATTR, 'true');
    refund.appendChild(mirror);
    refund.appendChild(makeNode(doc, 'span', REFUND_TAIL));
    textModal.appendChild(refund);

    // The new copy drops the campaign end date and FundPop's own refund line,
    // but both stay attached (hidden) so FundPop's updates keep finding them.
    carried.forEach(function (node) {
      if (!node) return;
      hide(node);
      textModal.appendChild(node);
    });

    textModal.setAttribute(COPY_ATTR, 'true');
    return true;
  }

  /* Re-applies formatting after FundPop rewrites an amount. Idempotent. */
  function syncAmounts(doc, textModal) {
    var changed = false;

    var amount = doc.getElementById(AMOUNT_ID);
    var remain = doc.getElementById(REMAIN_ID);

    [amount, remain].forEach(function (node) {
      if (!node) return;
      var formatted = formatAmount(node.textContent, node);
      if (formatted && node.textContent !== formatted) {
        node.textContent = formatted;
        changed = true;
      }
    });

    var mirror = textModal.querySelector('[' + MIRROR_ATTR + ']');
    if (mirror && amount && mirror.textContent !== amount.textContent) {
      mirror.textContent = amount.textContent;
      changed = true;
    }

    return changed;
  }

  function inlinePledgeText(doc) {
    doc = doc || (typeof document !== 'undefined' ? document : null);
    if (!doc) return false;

    var block = doc.getElementById('fundpop-pledge-block');
    if (!block) return false;

    var textModal = block.querySelector('.fundpop-pledge-text-modal');
    var paragraph = block.querySelector('p.fundpop-pledge-text');
    if (!textModal || !paragraph) return false;

    var changed = false;

    // Already inline and still in place — only the amounts may need a refresh.
    if (textModal.getAttribute(INLINED_ATTR) !== 'true' || textModal.parentElement !== block) {
      // Appending to the block lands it directly under the pledge line: the only
      // other child is the modal container, which stays display:none.
      block.appendChild(textModal);
      textModal.setAttribute(INLINED_ATTR, 'true');

      // Outside the modal the modal-scoped CSS no longer applies, so carry over
      // the inline styling FundPop puts on the pledge line from merchant settings.
      // Box chrome (border, padding, radius, margin) lives in tailwind.input.css so
      // it stays aligned with the Creator note under the buy button.
      if (paragraph.style) {
        if (paragraph.style.color) textModal.style.color = paragraph.style.color;
        if (paragraph.style.fontSize) textModal.style.fontSize = paragraph.style.fontSize;
      }

      var trigger = block.querySelector('.fundpop-pledge-modal-button');
      hide(trigger);

      changed = true;
    }

    if (renderCopy(doc, textModal)) changed = true;
    if (syncAmounts(doc, textModal)) changed = true;

    return changed;
  }

  window.RandamuFundpopPledge = {
    inlinePledgeText: inlinePledgeText,
    formatAmount: formatAmount,
    resolveTypeLabel: resolveTypeLabel,
  };

  if (typeof document === 'undefined') return;
  if (window.__randamuFundpopPledgeObserver) return;
  window.__randamuFundpopPledgeObserver = true;

  // The widget mounts (and re-renders) well after page load, same as the
  // footer observer in product-details.
  function apply() {
    inlinePledgeText(document);
  }

  apply();

  if (typeof MutationObserver === 'function' && document.documentElement) {
    var observer = new MutationObserver(apply);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', apply);
})();
